import React, { useEffect } from 'react'
import { useRouter } from 'next/router'
import { withAuth } from '../providers/auth'

function Root({ AuthStore }) {
  const router = useRouter()
  useEffect(() => {
    router.replace('/dashboard')
  }, [])
  return <></>
}

export default withAuth(Root)
